import helpButton from 'assets/helpButton.svg';

const HelpButton = () => (
  <a
    className="absolute flex items-center justify-center w-8 h-8 p-2 bg-gray-100 border border-gray-200 rounded-full shadow-sm"
    style={{
      right: '16px',
      bottom: '16px',
      boxShadow: '0px 2px 8px -2px rgba(0, 0, 0, 0.08), 0px 1px 2px rgba(0, 0, 0, 0.04)',
    }}
    href="mailto:contact@designpro.ai"
  >
    <img src={helpButton} alt="Help" className="w-4 h-4" />
  </a>
);

export default HelpButton;
